import { Redirect, Route, Switch } from 'react-router-dom';
import EditDebtCollectionCustomization from './EditDebtCollectionCustomization';
import { WorkflowFormAdd } from './WorkflowForm/WorkflowFormAdd';
import { WorkflowFormEdit } from './WorkflowForm/WorkflowFormEdit';
import { WorkflowsSettings } from './WorkflowsSettings';

export const WorkflowsRoutes = () => (
  <Switch>
    <Route
      exact
      path="/settings/workflows"
      render={() => <Redirect to="/settings/workflows/recovery-plans" />}
    />
    <Route
      path={[
        '/settings/workflows/recovery-plans/create',
        '/settings/workflows/recovery-plans/edit/:id',
      ]}
      component={EditDebtCollectionCustomization}
    />
    <Route path="/settings/workflows/:planType/create" component={WorkflowFormAdd} />
    <Route path="/settings/workflows/:planType/edit/:id" component={WorkflowFormEdit} />
    <Route path="/settings/workflows" component={WorkflowsSettings} />
  </Switch>
);
